import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import objectPath from 'object-path';
import screen from 'superior-mq';
import Container from '../../container';
import Waves from '../../waves';
import RenderMd from '../../render-md';
import PlayButton from '../../play-button';
import { YTModalContext } from '../../with-youtube-modal';

const CaseStudyHero = ({ logo, caseStudyProjectName, image, content, videoLink }) => (
  <Hero>
    <HeroContainer>

      {objectPath.has(image, 'fields.file.url') &&
        <figure>
          <HeroImage src={`${image.fields.file.url}?w=320&h=220&fit=thumb&q=80`} alt="" />
        </figure>
      }

      <TitleWrap>
        <h1 style={{ marginBottom: 0 }}>{caseStudyProjectName}</h1>

        {videoLink &&
          <YTModalContext.Consumer>
            {context => (
              <PlayVideo
                onClick={(e) => { context.toggleModal(e, videoLink); }}
                aria-label="Open video modal"
              />
            )}
          </YTModalContext.Consumer>
        }

      </TitleWrap>

      <HeroContent>
        <RenderMd source={content} />
      </HeroContent>

      {objectPath.has(logo, 'fields.file.url') &&
        <HeroLogo>
          <img src={logo.fields.file.url} alt="Logo" />
        </HeroLogo>
      }

    </HeroContainer>

    <Waves
      position="bottom"
      alignment="bottom"
      height={256}
      color="#fff"
    />
  </Hero>
);

const Hero = styled.section`
  position: relative;
  padding: 440px 0 250px;
  color: #fff;
  background-color: ${props => props.theme.black};
  text-align: center;
  z-index: 1;

  h1 {
    margin-bottom: 25px;
  }

  ${screen.below(bp.laptop, `
    padding: 370px 0 180px;
  `)}

  ${screen.below(bp.portrait, `
    padding: 250px 0 150px;
  `)}

  ${screen.below(bp.mobile, `
    padding: 180px 0 100px;
  `)}
`;

const HeroContainer = styled(Container)`
  position: relative;
`;

const TitleWrap = styled.div`
  position: relative;
  margin-bottom: 60px;

  ${screen.below(bp.laptop, `
    position: static;
    margin-bottom: 20px;
  `)}
`;

const PlayVideo = styled(PlayButton)`
  position: absolute;
  right: 0;
  bottom: -32px;
  left: 0;
  margin: auto;
  background-color: ${props => props.theme.blue};

  ${screen.below(bp.laptop, `
    position: static;
    margin-top: 10px;
  `)}
`;

const HeroContent = styled.div`
  max-width: 580px;
  margin: auto;
  text-align: center;
`;

const HeroImage = styled.img`
  position: absolute;
  top: -140px;
  left: 50%;
  z-index: -1;
  transform: rotate(8.6deg) translateX(-50%);

  ${screen.below(bp.mobile, `
    max-width: 180px;
    top: -70px;
  `)}
`;

const HeroLogo = styled.figure`
  max-width: 200px;
  margin: 40px auto 0 auto;

  ${screen.below(bp.mobile, `
    max-width: 120px;
  `)}
`;

CaseStudyHero.propTypes = {
  logo: PropTypes.object,
  caseStudyProjectName: PropTypes.string,
  image: PropTypes.object,
};

export default CaseStudyHero;
